import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./UserContext";
import Testata from "./partials/Testata";
import Footer from "./partials/Footer";
function NuovoAnnuncio() {
  const { userData } = useContext(UserContext);
  const [annunci, setAnnunci] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); 
  const [fileError, setFileError] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); 
  const [isSubmitting, setIsSubmitting] = useState(false); // Stato per il submit
  const navigate = useNavigate();
  // Definizione della funzione fetchCliente FUORI da useEffect
  const [regione, setRegione] = useState(null);

  const [formData, setFormData] = useState({
    id_utente: "",
    id_nek: "",
    testo: "",
    filename: "",
  });

  
  
  useEffect(() => {
    if (userData && userData.regione) {
      setRegione(userData.regione);
    }

    // Aggiorna formData solo dopo che userData è disponibile
    setFormData((prevFormData) => ({
      ...prevFormData,
      regione: userData ? userData.regione : null,
    }));
  }, [userData]); // Dipendenza da userData

  useState(false);  
  
  const regioni = [
    { sigla: 'Abruzzo', nome: 'Abruzzo' },
    { sigla: 'Basilicata', nome: 'Basilicata' },
    { sigla: 'Calabria', nome: 'Calabria' },
    { sigla: 'Campania', nome: 'Campania' },
    { sigla: 'Emilia Romagna', nome: 'Emilia Romagna' },
    { sigla: 'Friuli Venezia Giulia,', nome: 'Friuli Venezia Giulia,' },
    { sigla: 'Lazio', nome: 'Lazio' },
    { sigla: 'Liguria', nome: 'Liguria' },
    { sigla: 'Lombardia', nome: 'Lombardia' },
    { sigla: 'Marche', nome: 'Marche' },
    { sigla: 'Molise ', nome: 'Molise ' },
    { sigla: 'Piemonte', nome: 'Piemonte' },
    { sigla: 'Puglia', nome: 'Puglia' },
    { sigla: 'Sardegna', nome: 'Sardegna' },
    { sigla: 'Sicilia', nome: 'Sicilia' },
    { sigla: 'Toscana', nome: 'Toscana' },
    { sigla: 'Trentino Alto Adige', nome: 'Trentino Alto Adige' },
    { sigla: 'Umbria', nome: 'Umbria' },
    { sigla: 'Veneto', nome: 'Veneto' },
    { sigla: 'Valle d\'Aosta', nome: 'Valle d\'Aosta' },
  ];
  
  const fetchAnnunci = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`/api/annunciUser`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });

      if (response.ok) {
        const annunci = await response.json();
        setAnnunci(annunci);
      } else {
        throw new Error('Errore nel recupero degli Annunci'); // Messaggio di errore più specifico
      }
    } catch (err) {
      setError(err.message); // Imposta l'errore nello stato
    }
  };

  useEffect(() => {
    fetchAnnunci(); 
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    // Resetta l'errore all'inizio
    setFileError(null); 

    if (file) {
      console.log("fileError prima dei controlli:", fileError);
      // Ottieni l'estensione del file con split()
      const fileExtension = file.name.split('.').pop().toLowerCase(); 

      const allowedExtensions = ["jpg", "jpeg", "png"];
      if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
        setFileError("Attenzione!!! Solo JPG, JPEG e PNG di 2 Mb. al massimo.");
        setSelectedFile(null);
        // return; // NON uscire dalla funzione qui
      }

      // Controlla la dimensione del file (2 MB)
      if (file.size > 2 * 1024 * 1024) { 
        setFileError("Attenzione!!! Solo JPG, JPEG e PNG di 2 Mb. al massimo.");
        setSelectedFile(null);
        // return; // NON uscire dalla funzione qui
      }

      // Sposta il log qui, DOPO tutti i controlli
      console.log("fileError dopo i controlli:", fileError); 

      setFormData((prevFormData) => ({
        ...prevFormData,
        filename: file.name
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        filename: ''
      }));
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target; // Ottieni il valore del radio button selezionato
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value, // Aggiorna lo stato con il valore del radio button
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Imposta lo stato di submit a true
    try {
      const token = localStorage.getItem('token');
      const formDataToSend = new FormData();
      for (const key in formData) {
        if (key !== 'file') { // Salta il campo 'file' nel ciclo
          formDataToSend.append(key, formData[key]);
        }
      }
      if (selectedFile) { 
        formDataToSend.append('file', selectedFile);
      } 
      const response = await fetch(`/api/nuovo-allegato`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Cache-Control': 'no-cache'
        },
        credentials: 'include',
        body: formDataToSend
      });
      
      if (response.ok) {
        setShowSuccessMessage(true);
        // Nascondi il messaggio dopo un breve ritardo (opzionale)
        setTimeout(() => {
            setShowSuccessMessage(false);
        }, 3000); // Nascondi dopo 3 secondi
        setTimeout(() => {
            navigate('/dashboard'); // Reindirizza alla dashboard dopo il salvataggio
        }, 3100);
        } else {
        const errorData = await response.json();
        setError(errorData.error || 'Errore durante il salvataggio');
      }
    } catch (error) {
      console.error('Errore durante il caricamento:', error);
      if (error.message.includes('Formato del file non valido')) {
        setFileError('Attenzione!!! Sono ammessi solo JPG, JPEG e PNG di 2 Mb. al massimo.');
      } else if (error.message.includes('File troppo grande')) {
        setFileError('Attenzione!!! Sono ammessi solo JPG, JPEG e PNG di 2 Mb. al massimo.');
      } else if (error.message.includes('Codice fiscale già presente')) {
        // Gestisci l'errore del codice fiscale
      } else {
        alert('Si è verificato un errore sconosciuto durante il caricamento: ricarica la pagina e riprova.');
      }
      setIsSubmitting(false);
    }
  };

  function Option({ annuncio }) {
    return (
      <option key={annuncio._id} value={annuncio._id}>
        <span style={{ fontWeight: 'bold' }}>
          {annuncio.cognome} {annuncio.nome}
        </span>{' '}
        [{annuncio.cap} - {annuncio.comune} ({annuncio.prov})]
      </option>
    );
  }
  return (
    <>
      <section className="main_content dashboard_part">
        <div className='className="container-fluid g-0'>            
            <Testata userData={userData} />
        </div>
        <div className="main_content_iner ">
          <div className="container-fluid plr_30 body_white_bg pt_30">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="white_box_tittle list_header">
                  <h4><a href="/dashboard"><i className="ti-arrow-circle-left" style={{fontSize: '0.8rem'}}></i> Indietro</a> &nbsp; | &nbsp; Nuovo Allegato</h4>                  
                </div>
                {error && <p className="error-message">{error}</p>}
                  <form onSubmit={handleSubmit}>
                    <div className="col-12 mb_30">
                      <div className="row">
                        <div className="form-group col-sm-12 mb_30">
                          <label htmlFor="id_nek">
                            Seleziona l'annuncio cui ci si riferisce <b className="text text-danger">*</b>:
                          </label>
                          <select
                            className="form-select form-control"
                            id="id_nek"
                            name="id_nek"
                            value={formData.id_nek}
                            onChange={handleChange}
                            required
                            aria-required="true"
                          >
                            <option value="">Seleziona l'annuncio cui si riferisce questo allegato</option> 
                            {annunci && annunci
                              .sort((a, b) => { // Ordina gli annunci
                                // Confronta i cognomi
                                const cognomeA = a.cognome.toLowerCase();
                                const cognomeB = b.cognome.toLowerCase();
                                if (cognomeA < cognomeB) return -1;
                                if (cognomeA > cognomeB) return 1;

                                // Se i cognomi sono uguali, confronta i nomi
                                const nomeA = a.nome.toLowerCase();
                                const nomeB = b.nome.toLowerCase();
                                if (nomeA < nomeB) return -1;
                                if (nomeA > nomeB) return 1;

                                return 0; // Se cognomi e nomi sono uguali
                              })
                              .map(annuncio => ( 
                                <Option annuncio={annuncio} /> 
                              ))}
                          </select>
                        </div>
                      </div>         
                    </div>
                    <div className="row">
                      <div className="form-group col-md-12 mb_20">
                        {/* Modulo di caricamento dell'immagine */}
                          <div className='row mb_20'>
                            <div className="col-lg-4 col-md-2 col-sm-3 col-xs-1"></div>
                            <div className='col-lg-4 col-md-8 col-sm-6 col-xs-10 alert alert-warning'>
                              <h4 className="text text-danger mb_20">Tutti i campi sono obbligatori</h4>
                              <h3>ATTENZIONE:</h3>
                              Non sono consentiti file non rispondenti ai seguenti requisiti:
                              <ul>
                                <li> &nbsp; a) Dimensioni: <b>non</b> superiori a <b>2 MegaBytes</b></li>
                                <li> &nbsp; b) Formato: <b>.JPG/.JPEG</b> o <b>.PNG</b></li>
                                <li> &nbsp; c) Dimensioni massime: <b>1920 x 1280 px</b>, 72 dpi</li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-12 mb_20">
                            <div className="input-group mb-3">
                              <label className="form-label" htmlFor="file">Scegli il file dal tuo device <b className="text text-danger">*</b>:
                                <input type="file" className="form-control" name="file" id="file" onChange={handleFileChange} required aria-required="true" />
                              </label>
                            </div>
                            {fileError && (
                              <p style={{fontWeight: "500", color: "#CC0000"}}>{fileError}</p>
                            )}
                          </div>
                        </div>                      
                        <div className="form-group col-md-8 col-sm-12 mb_20" style={{textAlign: 'right'}}>
                          {showSuccessMessage && ( // Mostra il messaggio solo se showSuccessMessage è true
                            <div className="alert alert-success mt_20" role="alert">Pubblicato con successo!</div>
                          )}
                          <button type="submit" className="btn btn-primary mt_20" disabled={fileError}> {/* Disabilita il pulsante se il codice fiscale è presente 2 o più volte o il file non rispetta le regole indicate */}
                            Salva
                          </button>
                        </div>
                      </div>
                  </form>                
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default NuovoAnnuncio;